import { useEffect, useState } from 'react';
import { cardCategoryServedEvent } from '../../../Utils/StoreHomePageUtils';
import CategoryFilter from './CategoryFilter';
import CategoryProducts from './CategoryProducts';
import { CategoryFilterSection, CategoryTitle } from './styled';

export default function ProductByCategoryGenralItem(props) {
  const { data, type } = props;
  const productByCategoryData = data?.items;
  const allKeyValues = [
    ...new Set(productByCategoryData.map((curElem) => curElem.key)),
  ];
  const initialCardData = { ...productByCategoryData[0] };
  const initialData = [initialCardData];
  const [cardItems, setCardItems] = useState(initialData);
  const [filterCategoryName, setFilterCategoryName] = useState(allKeyValues);

  const filterCategories = (categoryWise) => {
    const updateItems = productByCategoryData.filter((curElem) => {
      return curElem.key === categoryWise;
    });

    setCardItems(updateItems);
  };

  useEffect(() => {
    cardCategoryServedEvent(data);
  }, []);

  return (
    <CategoryFilterSection bg={data?.sectionBgImage}>
      <CategoryTitle>{data?.heading}</CategoryTitle>
      <CategoryFilter
        filterCategoryName={filterCategoryName}
        filterCategories={filterCategories}
        section_name={data?.heading}
        section_id={data?._id}
      />
      <CategoryProducts cardItems={cardItems} type={type} data={data} />
    </CategoryFilterSection>
  );
}
